var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", staticStyle: { position: "relative" } },
    [
      _c("ie-detail-workspace", {
        ref: "bookingWorkspace",
        attrs: { "parent-context": _vm.context, "open-multiple": true },
        on: { back: _vm.backToList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }